import script from "./Work.vue?vue&type=script&setup=true&lang=js"
export * from "./Work.vue?vue&type=script&setup=true&lang=js"

import "./Work.vue?vue&type=style&index=0&id=63b66d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b66d19"]])

export default __exports__